// Reuse native timezone formatters instead of constructing one for every EPG date.
export const createServerDateFormatter = (timeZone: string) => {
  let dateFormatter: Intl.DateTimeFormat | undefined;
  let dateTimeFormatter: Intl.DateTimeFormat | undefined;

  return (date: Date, includeTime: boolean) => {
    if (typeof Intl === 'undefined' || typeof Intl.DateTimeFormat !== 'function') {
      return includeTime
        ? date.toLocaleString('en-US', { timeZone })
        : date.toLocaleDateString('en-US', { timeZone });
    }
    if (includeTime) {
      if (!dateTimeFormatter) {
        dateTimeFormatter = new Intl.DateTimeFormat('en-US', {
          timeZone,
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric'
        });
      }
      return dateTimeFormatter.format(date);
    }
    if (!dateFormatter) {
      dateFormatter = new Intl.DateTimeFormat('en-US', {
        timeZone,
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      });
    }
    return dateFormatter.format(date);
  };
};
